import { render, staticRenderFns } from "./revenueDetails.vue?vue&type=template&id=10bc137c&scoped=true&"
import script from "./revenueDetails.vue?vue&type=script&lang=js&"
export * from "./revenueDetails.vue?vue&type=script&lang=js&"
import style0 from "./revenueDetails.vue?vue&type=style&index=0&id=10bc137c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc137c",
  null
  
)

export default component.exports